import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-foreground-900 text-white">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
          <div className="md:col-span-4">
            <div className="flex items-center gap-3 mb-4">
              <span className="font-heading text-xl font-semibold">
                OOPBUY Spreadsheet Guide
              </span>
            </div>
            <p className="text-foreground-400 text-sm leading-relaxed max-w-[320px]">
              {t("footer_description")}
            </p>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-semibold mb-4 text-white">
              {t("footer_products")}
            </h4>
            <div className="flex flex-col gap-2.5">
              <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap">
                Shoes
              </a>
              <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap">
                Hoodies
              </a>
              <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap">
                T-Shirts
              </a>
              <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap">
                Jackets
              </a>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-semibold mb-4 text-white">
              {t("footer_guides_title")}
            </h4>
            <div className="flex flex-col gap-2.5">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap">
                OOPBUY Guide
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap">
                Kategorien
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap">
                Sicherheit
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap">
                FAQ
              </a>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-semibold mb-4 text-white">
              {t("footer_support")}
            </h4>
            <div className="flex flex-col gap-2.5">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap">
                Kontakt
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap">
                Versand
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap">
                Datenschutz
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap">
                Impressum
              </a>
            </div>
          </div>

          <div className="md:col-span-2">
            <div className="font-heading text-lg font-semibold mb-1">Schneller.</div>
            <div className="font-heading text-lg font-semibold mb-1">Besser.</div>
            <div className="font-heading text-lg font-semibold mb-4">Sicherer.</div>
            <div className="flex gap-3">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-base w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-pinterest-line text-base w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-reddit-line text-base w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-medium-line text-base w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-700/30 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sm text-foreground-500">
            &copy; {new Date().getFullYear()} OOPBUY Spreadsheet Guide. {t("footer_copyright")}
          </p>
          <p className="text-xs text-foreground-600 italic">
            Unabhängiges Informationsportal. Nicht offiziell mit OOPBUY verbunden.
          </p>
        </div>
      </div>
    </footer>
  );
}